// Constants for E-Visit related text
export const EVISIT_TEXT_EN = 'E-Visit';
export const EVISIT_TEXT_ES = 'consulta electrónica';
